import { DetailSectionTemplate } from "components/MainSectionTemplate/DetailSectionTemplate"
import LifecycleSteps, { LifecycleStepsType, StepOptions } from "components/Steps/LifecycleSteps";
import React from "react"
import { SectionTemplateBrField } from "components/MainSectionTemplate/SectionTemplateBrField";
import SmallDetails from "components/SmallDetails/SmallDetails";
import { formatDaysSince, formatWrittenDayMonthYear } from "utilities";
import { Due } from "../Due";
import { BookkeepingSmallDetails } from "components/SmallDetails";
import { YesNoText } from "components/ValidatedFields/YesNoRadioGroup";

interface ESignInfoSectionProps {
  documentType: server.dto.DocumentTypes
  stepOptions: StepOptions
  overDue: boolean
  activeStep: LifecycleStepsType
  esignDocument: server.dto.ESignDocument
  brands: server.dto.BrandSmall[]
}

export const ESignInfoSection = (props: ESignInfoSectionProps) => {

  const hasOnlyOneBrand = props.brands.length === 1;

  const displayInReviewSince = props.esignDocument.lifeCycle.value === "review";
  const displayPendingSince = props.esignDocument.lifeCycle.value === "pending";
  const displaySendDate = props.esignDocument.lifeCycle.value === "completed" ||
    props.esignDocument.lifeCycle.value === "discarded";
  const displayCompletedDate = props.esignDocument.lifeCycle.value === "completed";
  const displayDiscardedDate = props.esignDocument.lifeCycle.value === "discarded";
  const displayDueDate = props.esignDocument.lifeCycle.value === "review" ||
    props.esignDocument.lifeCycle.value === "pending";
  const displayAllowAutoSign = props.esignDocument.lifeCycle.value === "review" ||
    props.esignDocument.lifeCycle.value === "pending";
  const hideSteps = props.esignDocument.lifeCycle.value === "discarded";

  return <DetailSectionTemplate
    isInPageEditable={false}
    onValueChanged={() => { }}
    sections={[{
      key: "esignDetails",
      type: "regular",
      title: `${site.currentEnvironment[props.documentType].singular} ${RESX.ESign.eSign}`,
      subTitle: props.esignDocument.lifeCycle.value === "discarded"
        ? RESX.DocumentLifeCycle.Discarded
        : `${RESX.ESign.Version} ${props.esignDocument.version}`,
      supportArticleId: serverReference.supportArticleIds.whatIsESigning,
      fields: [{
        key: "lifecycleSteps",
        label: "",
        hidden: hideSteps,
        hideLabel: true,
        compact: true,
        render: () => <LifecycleSteps
          documentType={props.documentType}
          stepOptions={props.stepOptions}
          overDue={props.overDue}
          activeStep={props.activeStep}
          documentId={props.esignDocument.documentId}
        />
      }, SectionTemplateBrField("br", hideSteps), {
        key: "documentNumber",
        label: RESX.Document.DocumentNumber,
        hidden: !props.esignDocument.documentNumber,
        render: () => <div>{props.esignDocument.documentNumber}</div>
      }, {
        key: "inReviewSince",
        label: RESX.DocumentLifeCycle.InReview,
        hidden: !displayInReviewSince,
        render: () => <SmallDetails
          label={formatWrittenDayMonthYear(props.esignDocument.sendDate)}
          subLabel={formatDaysSince(props.esignDocument.sendDate)}
        />
      }, {
        key: "pendingSince",
        label: RESX.DocumentLifeCycle.OutForSignature,
        hidden: !displayPendingSince,
        render: () => <SmallDetails
          label={formatWrittenDayMonthYear(props.esignDocument.sendDate)}
          subLabel={formatDaysSince(props.esignDocument.sendDate)}
        />
      }, {
        key: "sendDate",
        label: RESX.DateTime.SendDate,
        hidden: !displaySendDate,
        render: () => <SmallDetails
          label={formatWrittenDayMonthYear(props.esignDocument.sendDate)}
        />
      }, {
        key: "completedDate",
        label: RESX.DocumentLifeCycle.Completed,
        hidden: !displayCompletedDate,
        render: () => <SmallDetails
          label={formatWrittenDayMonthYear(props.esignDocument.completedUtc)}
        />
      }, {
        key: "discardedDate",
        label: RESX.DocumentLifeCycle.Discarded,
        hidden: !displayDiscardedDate,
        render: () => <SmallDetails
          label={formatWrittenDayMonthYear(props.esignDocument.completedUtc)}
        />
      }, {
        key: "dueDate",
        label: RESX.DateTime.Due,
        hidden: !displayDueDate,
        render: () => <Due
          lifeCycle={props.esignDocument.lifeCycle.value}
          sendDate={props.esignDocument.sendDate}
          dueInDays={props.esignDocument.dueInDays}
        />
      }, {
        key: "bookkeeping",
        label: RESX.Bookkeeping.resxBookkeeping,
        render: () => <BookkeepingSmallDetails
          bookkeeping={props.esignDocument.bookkeeping}
        />
      }, {
        key: "brand",
        label: RESX.Branding.resxBranding,
        hidden: hasOnlyOneBrand,
        render: () => <div>{props.esignDocument.brand?.name}</div>,
      }, {
        key: "allowAutoSign",
        label: RESX.ESign.AllowAutoSign,
        supportArticleId: serverReference.supportArticleIds.autoSign,
        hidden: !displayAllowAutoSign,
        render: () => <YesNoText value={props.esignDocument.allowAutoSign} />,
      }],
    }]}
  />
}